export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@popperjs/core/lib/utils/getVariation.js
// module id = 240
// module chunks = 3